import { render, staticRenderFns } from "./OpeningHourPair.vue?vue&type=template&id=755caa68&scoped=true"
import script from "./OpeningHourPair.vue?vue&type=script&lang=js"
export * from "./OpeningHourPair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755caa68",
  null
  
)

export default component.exports